export default "__VITE_ASSET__DcsR39Mz__"